import * as React from 'react';
import clsx from 'clsx';
import { ISwitcherItem, SwitcherItem } from './switcher-item';

import './style.scss';

/* eslint-disable @typescript-eslint/indent */
type PickDivProps = Pick<
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    'className' | 'style'
>;
/* eslint-enable @typescript-eslint/indent */


export interface ISwitcherProps extends PickDivProps {
    items: ISwitcherItem[];
    value: ISwitcherItem['code'];
    /** Срабатывает только если кликнули на не активную вкладку */
    onChange: (current_active_item: ISwitcherItem) => void;
    /** Срабатывает при каждом клике по вкладке даже если нажали уже на активную вкладку */
    onTabClick?: (tab: ISwitcherItem) => void;
}
export interface ISwitcherState {
    /**
     * Нужно чтоб компонент перерендерился после того как он будет впервые отрендерен.
     * Нужно это потому что все ref'ы на `SwitcherItem` появятся только после того как
     * в первый раз выполнится render. А метод, который считает позицию бегунка (для обозначения выбранного элемента)
     * как раз во время рендера и вызывается
     */
    is_mounted: boolean;
}

class SwitcherComponent extends React.Component<ISwitcherProps, ISwitcherState> {
    private switcher_items: Map<ISwitcherItem['code'], HTMLDivElement> = new Map();

    constructor(props: ISwitcherProps) {
        super(props);

        this.state = {
            is_mounted: false
        };

        this.onTrackItemClick = this.onTrackItemClick.bind(this);
    }

    componentDidMount() {
        this.setState({
            is_mounted: true
        });
    }

    onTrackItemClick(item: ISwitcherItem) {
        this.props.onTabClick?.(item);
        if (this.props.value !== item.code) {
            this.props.onChange(item);
        }
    }

    calcThumbPosition() {
        let active_item = this.props.items.find(i => i.code === this.props.value);
        let item_div = this.switcher_items.get(active_item.code);
        return {
            left: item_div?.offsetLeft ?? 0,
            width: item_div?.clientWidth ?? 0
        };
    }

    render() {
        let thumb_position = this.calcThumbPosition();
        return (
            <div
                className={clsx('switcher-wrapper', this.props.className)}
                style={this.props.style}
            >
                <div
                    className="thumb"
                    style={{
                        left: thumb_position.left,
                        width: thumb_position.width
                    }}
                />
                <div className="track-wrapper">
                    {
                        this.props.items.map(item => (
                            <SwitcherItem
                                key={item.code}
                                item={item}
                                onClick={this.onTrackItemClick}
                                active={item.code === this.props.value}
                                ref={(el) => {
                                    this.switcher_items.set(item.code, el);
                                }}
                            />
                        ))
                    }
                </div>
            </div>
        );
    }
}

export const Switcher = SwitcherComponent;
